import React from "react";
import emailjs from "emailjs-com";
import Footer from "../components/footer";
import { createGlobalStyle } from "styled-components";
import { init } from "emailjs-com";

init("user_1dzi5g7FzkHIoPHu7RSNA");

const GlobalStyles = createGlobalStyle`
  header#myHeader.navbar.white {
    background: #FAF6F1;
    border-bottom: solid 1px #ccc !important;
  }
`;

const contact = function () {
  function sendEmail(e) {
    const success = document.getElementById("success");
    const button = document.getElementById("buttonsent");
    const failed = document.getElementById("failed");
    e.preventDefault();

    emailjs
      .sendForm(
        "service_7tow7vn",
        "template_ylks3cj",
        e.target,
        "user_1dzi5g7FzkHIoPHu7RSNA"
      )
      .then(
        (result) => {
          console.log(result.text);
          success.classList.add("show");
          button.classList.add("show");
          failed.classList.remove("show");
        },
        (error) => {
          console.log(error.text);
          failed.classList.add("show");
        }
      );
  }

  return (
    <div>
      <GlobalStyles />

      <section className="jumbotron breadcumb no-bg">
        <div className="mainbreadcumb">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1>About Copycats</h1>
                <p>Copycats Copyright Registry</p>
                <br />
                <p>
                  Using immutable distributed ledger technology, Copycats
                  provides irrefutable proof of copyright claims<br/>by IP owners
                  that can be used to attest in a court of law. This improves
                  the efficiency of legal enforcement<br/>& at the same times, deter
                  any false claims using Copycats sound KYC<sup>2</sup> system.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="container">
        <div className="row">
          <div className="col-lg-8 mb-3">
            <h3>Have a question, suggestion or feedback?</h3>
            <div className="form-side">
              <form className="formcontact" onSubmit={sendEmail}>
                <input
                  type="text"
                  className="form-control"
                  name="user_name"
                  placeholder="Your name"
                  required
                />
                <input
                  type="email"
                  className="form-control"
                  name="user_email"
                  placeholder="Your email address"
                  required
                />
                <input
                  type="text"
                  className="form-control"
                  name="user_phone"
                  placeholder="Your contact number (optional)"
                />
                <textarea
                  name="message"
                  className="form-control"
                  placeholder="Your message for us"
                  required
                />
                <div id="success" className="hide">
                  Your message has been sent...
                </div>
                <div id="failed" className="hide">
                  Message failed...
                </div>
                <input
                  type="submit"
                  id="buttonsent"
                  value="Submit Now"
                  className="btn btn-main color-2"
                />
              </form>
            </div>
          </div>

          <div className="col-md-4">
            <div className="padding40 box-rounded mb30">
              <h3>Global Office</h3>
              <address className="s1">
                <span>
                  <i className="id-color fa fa-map-marker fa-lg"></i>Singapore
                  (HQ)
                </span>
                <span>
                  <i className="id-color fa fa-phone fa-lg"></i>+65 9179 5711
                </span>
                <span>
                  <i className="id-color fa fa-envelope-o fa-lg"></i>
                  <a className="btn" href="mailto:mark@copycats.sg">
                    cattery@copycats.sg
                  </a>
                </span>
              </address>
            </div>

            <div className="padding40 box-rounded mb30 text-light">
              <h3>Investor Relations</h3>
              <address className="s1">
                <span>
                  <i className="fa fa-file-pdf-o fa-lg"></i>
                  <span className="btn">Request for Teaser</span>
                </span>
                <span>
                  <i className="fa fa-phone fa-lg"></i>+65 9821 2992
                </span>
                <span>
                  <i className="fa fa-envelope-o fa-lg"></i>
                  <a className="btn" href="mailto:mark@copycats.sg">
                    adopt@copycats.sg
                  </a>
                </span>
              </address>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};
export default contact;
